const colors = {
  blue: '#00d9f7',
  darkblue: '#01616f',
  purple: '#7a76ee',
  green: '#00ff88',
  darkgreen: '#33937f',
  orange: '#ffbb33',
  midgray: '#777788',
  gray: '#333339',
  red: '#ff5050',

  info: '#fb3',
  iconInfo: '#00d9f7',
  success: '#0f8',
  warning: '#fb3',
  primary: '#66666a',
  secondary: '#00d9f7',
  error: '#ff5050',

  class: {
    deathknight: '#c41f3b',
    'death knight': '#c41f3b',
    demonhunter: '#a330c9',
    'demon hunter': '#a330c9',
    druid: '#ff7d0a',
    evoker: '#33937f',
    hunter: '#abd473',
    mage: '#69ccf0',
    monk: '#00ff96',
    priest: '#ffffff',
    paladin: '#f58cba',
    rogue: '#fff569',
    shaman: '#0070de',
    warlock: '#9482c9',
    warrior: '#c79c6e',
  },
  items: {
    0: '#9d9d9d', // junk
    1: '#ffffff', // common
    2: '#1eff00', // uncommon
    3: '#0070dd', // rare
    4: '#a335ee', // epic
    5: '#ff8000', // legendary
    6: '#e6cc80', // artifact
    7: '#00ccff', // heirloom
    8: '#00ccff', // wow token
    72: '#e6cc80',
  },

  // 8.3 colors
  corruption: '#956dd1',
  purify: '#fff100',
};

// Dark-friendly severity tints for inline indicators (chips/banners/icons):
// softer text + tinted fills that read on the dark panel instead of the harsh
// full-saturation red/yellow. `base` is the solid accent (matches error/warning
// above); soft/softer/border/text/icon are the derived tones.
export const tones = {
  error: {
    base: colors.error, // #ff5050
    text: '#ff9a9a',
    icon: '#ff6b6b',
    soft: 'rgba(255, 80, 80, 0.14)',
    softer: 'rgba(255, 80, 80, 0.08)',
    border: 'rgba(255, 80, 80, 0.45)',
  },
  warning: {
    base: colors.warning, // #fb3
    text: '#ffd27a',
    icon: '#ffc04d',
    soft: 'rgba(255, 187, 51, 0.14)',
    softer: 'rgba(255, 187, 51, 0.08)',
    border: 'rgba(255, 187, 51, 0.45)',
  },
  info: {
    base: colors.iconInfo, // #00d9f7
    text: '#9fe8f6',
    icon: '#00d9f7',
    soft: 'rgba(0, 217, 247, 0.14)',
    softer: 'rgba(0, 217, 247, 0.08)',
    border: 'rgba(0, 217, 247, 0.45)',
  },
};

export default colors;
